import { Control, Field, Input } from "@allxsmith/bestax-bulma";
import React from "react";
import useInlineEditButton from "./useInlineEditButton";

function useEditableTableTextCell({
  propName,
  value,
  onChange,
  onSave,
  editable,
  setEditable,
  disabled,
  inlineEdit,
  tdClass
}) {
  return (
    <td onClick={e => e.stopPropagation()} className={tdClass}>
      <Field className="has-addons">
        <Control>
          <Input
            className="small-row-black"
            onChange={onChange}
            type="text"
            name={propName}
            value={value}
            disabled={!editable}
          />
        </Control>
        {useInlineEditButton({show: inlineEdit, onSave, setEditable, editable, disabled})}
      </Field>
    </td>
  );
}

export default useEditableTableTextCell;
